$(function ($) {

    var $siteHeader = $('.main-nav');
    var $siteNavigation = $('.main-nav__navigation-wrapper');
    var $openNavigation = $('.main-nav__open-nav');
    var $closeNavigation = $('.main-nav__close-nav');

    $openNavigation.on('click', function () {
      if(!$siteNavigation.hasClass('main-nav__navigation--show')) {
        $siteNavigation.addClass('main-nav__navigation--show')
      }
    });

    $closeNavigation.on('click', function () {
      if($siteNavigation.hasClass('main-nav__navigation--show')) {
        $siteNavigation.removeClass('main-nav__navigation--show')
      }
    });

    var $searchOptionButton = $('.main-nav__option-link--search');
    var $searchProducts =  $('.search-products');
    var $closeSearchButton = $('.search-products__close-search');

    $searchOptionButton.on('click', function () {
      if(!$searchProducts.hasClass('search-products--show')) {
        $searchProducts.addClass('search-products--show');

        initSearchCategorySlider();
      }
    });

    $closeSearchButton.on('click', function () {
      if($searchProducts.hasClass('search-products--show')) {
        $searchProducts.removeClass('search-products--show');
      }
    });

    /*---------------- Featured Products Slider ------------------*/
    jQuery('.featured-products__list').each(function () {
      jQuery(this).slick({
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    });

    function initSearchCategorySlider() {
      if(jQuery('#search-category-slider').length && !jQuery('#search-category-slider').hasClass('slick-initialized')) { 
        jQuery('#search-category-slider').slick({
          infinite: true,
          dots: false,
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 989,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    }

    if ($(window).width() < 767) {
        /*---------------- Responsive Menu ------------------*/
        $(".nav-trigger").on('click', function (e) {
            $("body").toggleClass('off-canvas-body');
            $(".menu-bar").toggleClass("off-canvas");
            e.preventDefault();
        });

        $('.main-header .dropdown > a > span').on("click", function (e) {
           // $(this).parent('.dropdown').toggleClass('active');
           // $(this).next('.dropdown-menu').slideToggle(600);
            $('.main-header .dropdown > a').toggleClass('active');
            $('.main-header .dropdown > a').next('.dropdown-menu').toggle();
            $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-right');
            e.stopPropagation();
            e.preventDefault();
        });
    }
    /*---------------- Main Slider ------------------*/
    $('.main-slider').slick({
      autoplay: false,
      arrows: false,
      dots: true
    });
  
    /*---------------- Search Popup ------------------*/
    $(".search-toggle").on('click', function (e) {
      $(".serch-popup").slideToggle(600);
      e.preventDefault();
      e.stopPropagation();
    });
    $(".serch-popup").click(function (e) {
      e.stopPropagation();
    });

    /*---------------- Video Popup ------------------*/
  
  if($('.popup-video').length > 0) {
      $('.popup-video').magnificPopup({
      disableOn: 200,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
      }
    });
  }

    /*---------------- Featured Slider ------------------*/
    $('.featured-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerPadding: '40px',
      arrows: true,
      responsive: [
        {
          breakpoint: 1501,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
  /*------------- product page starts -----------------------*/
  
  
  // This button will increment the value
    $('.btn.cartplus').click(function (e) {
	  var newqty = parseInt($('.customizeqty').val());	
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      
      // Get its current value
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
       //alert(currentVal.length());
      var newcurrentVAl = parseInt($(this).closest('tr').find('td .cart__qty-input').val());
      //alert(newcurrentVAl)
     
      // If is not undefined
      if (!isNaN(newcurrentVAl)) {
        // Increment
        $('input[id=' + fieldName + ']').val(newcurrentVAl + 1);
        $('.customizeqty').val(newqty+1);
      } else {
        // Otherwise put a 0 there
        $('input[id=' + fieldName + ']').val(1);
        $('.customizeqty').val(newqty);
      }
    });
    // This button will decrement the value till 0
    $(".btn.cartminus").click(function (e) {
 var newqty = parseInt($('.customizeqty').val());	
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
       var newcurrentVAl = parseInt($(this).closest('tr').find('td .cart__qty-input').val());
      //alert(newcurrentVAl)
     
      // If it isn't undefined or its greater than 0
      if (!isNaN(newcurrentVAl) && newcurrentVAl > 1) {
        // Decrement one
        $('input[id=' + fieldName + ']').val(newcurrentVAl - 1);
        $('.customizeqty').val(newqty-1);
      } else {
        // Otherwise put a 0 there
        $('input[name=' + fieldName + ']').val(1);
        $('.customizeqty').val(newqty);
      }
    });

    // This button will increment the value
    $('.btn.plus').click(function (e) {
	  var parent = $(this).parent('.quantity');
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      
      // Get its current value
      var currentVal = parseInt($(parent).find('input[name=' + fieldName + ']').val());
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment
        $(parent).find('input[name=' + fieldName + ']').val(currentVal + 1);
      } else {
        // Otherwise put a 0 there
        $(parent).find('input[name=' + fieldName + ']').val(1);
      }
    });
    // This button will decrement the value till 0
    $(".btn.minus").click(function (e) {
 	  var parent = $(this).parent('.quantity');
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($(parent).find('input[name=' + fieldName + ']').val());
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        $(parent).find('input[name=' + fieldName + ']').val(currentVal - 1);
      } else {
        // Otherwise put a 0 there
        $(parent).find('input[name=' + fieldName + ']').val(1);
      }
    });

    $('.quantity-options__quantity-option--decrease').click(function (event) {
      var $quantityIndicator = $(this).next('input');
      var quantityValue = parseInt($quantityIndicator.val(), 10);
      if(quantityValue >= 2) {
        $quantityIndicator.val(quantityValue - 1);
      }
      event.preventDefault();
    });

    $('.quantity-options__quantity-option--increase').click(function (event) {
      var $quantityIndicator = $(this).prev('input');
      var quantityValue = parseInt($quantityIndicator.val(), 10);
      if(quantityValue <= 29) {
        $quantityIndicator.val(quantityValue + 1);
      }
      event.preventDefault();
    });

    $('.quantity-options__quantity-indicator').each(function () {
      var $input = $(this)[0];
      setInputFilter($input, function(value) {
        return /^[1-9][0-9]*$/.test(value); // Allow digits and '.' only, using a RegExp
      });
    })

    function setInputFilter(textbox, inputFilter) {
      ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
        textbox.addEventListener(event, function() {
          if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          } else {
            this.value = "";
          }
        });
      });
    }

    if($('.product-unit__gallery-list').length) {
      $('.product-unit__gallery-list').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000
      });
    }

    /*---------------- Featured Slider ------------------*/
    $('.related-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerPadding: '40px',
      arrows: true,
      responsive: [
        {
          breakpoint: 1501,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

/*------------- product page ends-----------------------*/
    var windowScrollTopPosition = 0;
    $(window).on('scroll', function () {
      windowScrollTopPosition = $(window).scrollTop();
      if(windowScrollTopPosition > 25) {
        if(!$siteHeader.hasClass('main-nav--highlight')) {
          $siteHeader.addClass('main-nav--highlight');
        }
      } else {
        if($siteHeader.hasClass('main-nav--highlight')) {
          $siteHeader.removeClass('main-nav--highlight');
        }
      }
    });
});

$(function () {

  
  var HomeBannerSlider = function () {
    var homeBanner = document.querySelector('.home-banner .home-banner__slider');

    var prevButton = document.querySelector('.home-banner__control--prev');
    var nextButton = document.querySelector('.home-banner__control--next');

    var slideItem = document.querySelector('.home-banner__item');
    var slideTitle = document.querySelector('.home-banner__item-title');
    var slideDescription = document.querySelector('.home-banner__item-description');
    var slideImage = document.querySelector('.home-banner__item-image');
    var slideLink = document.querySelector('.home-banner__item-link');

    var slideIndicator = document.querySelector('.home-banner__indicator');
    var slideIndicatorNumber = document.querySelector('.home-banner__indicator-number');
    var slideIndicatorNumberTop = 0;

    var slidesInfo = [];

    var currentSlide;
    var currentSlideIndex = 0;

    var transitionInMotion = false;

    function initSlider() {
      var slideItemsInfo = Array.prototype.slice.call(document.querySelectorAll('.home-banner__slide-info'));
      slideItemsInfo.forEach(function (item) {
        var slideInfo = {
          title: item.querySelector('.home-banner__slide-title').textContent,
          description: item.querySelector('.home-banner__slide-description').textContent,
          image: item.querySelector('.home-banner__slide-image').textContent,
          link: item.querySelector('.home-banner__slide-link').textContent
        }

        slidesInfo.push(slideInfo);
      });

      if(slidesInfo.length) {
        prevButton.addEventListener('click', function () {
          if(transitionInMotion) {
            return false;
          }

          if(currentSlideIndex === 0) {
            currentSlideIndex = slidesInfo.length - 1;
          } else {
            currentSlideIndex--;
          }

          currentSlide = slidesInfo[currentSlideIndex];
          changeSlide(currentSlide);
        });

        nextButton.addEventListener('click', function () {
          if(transitionInMotion) {
            return false;
          }

          if(currentSlideIndex >= slidesInfo.length - 1) {
            currentSlideIndex = 0;
          } else {
            currentSlideIndex++;
          }

          currentSlide = slidesInfo[currentSlideIndex];
          changeSlide(currentSlide);
        });
        
      }

      function changeSlide(slideToShow) {
        if(!slideToShow) {
          if(currentSlideIndex < slidesInfo.length - 1) {
            var slideToShow = slidesInfo[currentSlideIndex + 1];
            currentSlideIndex += 1;
          } else {
            var slideToShow = slidesInfo[0];
            currentSlideIndex = 0;
          }
        }

        if(slideItem) {
          slideItem.classList.add('home-banner__item--obscure');
          transitionInMotion = true;
  
          //slideIndicator.querySelector('.home-banner__indicator-line.home-banner__indicator-line--active').classList.remove('home-banner__indicator-line--active');
  
          //slideIndicatorNumberTop = 8 * currentSlideIndex;
  
          setTimeout(function () {
            slideTitle.textContent = slideToShow.title;
            slideDescription.textContent = slideToShow.description;
            slideImage.src = slideToShow.image;
            slideLink.href = slideToShow.link;
  
            // slideIndicator.querySelector('.home-banner__indicator-line:nth-child(' + (currentSlideIndex + 1)  + ')').classList.add('home-banner__indicator-line--active');
            // slideIndicatorNumber.textContent = '0' + (currentSlideIndex + 1);
            // slideIndicatorNumberTop = 8 * currentSlideIndex;
            // slideIndicatorNumber.style.transform = 'translateY(' + slideIndicatorNumberTop + 'px)';
          }, 300);
  
          setTimeout(function () {
            slideItem.classList.remove('home-banner__item--obscure');
            transitionInMotion = false;
          }, 400);
        }
      };

      setTimeout(function () {
        setInterval(function(){
          changeSlide();
        }, 4000);  
      }, 6000);

    };

    return {
      init: initSlider,

    }
  };

  var sliderUnit = HomeBannerSlider();
  sliderUnit.init();
});

document.addEventListener('lazybeforeunveil', function(e) {
  var bg = e.target.getAttribute('data-bg');
  if(bg){
      e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

window.addEventListener('DOMContentLoaded', function(e) {
  var head = document.getElementsByTagName('head')[0];
  cssFiles.forEach(function (file) {
      var link = document.createElement('link');
      link.setAttribute('href', file.url);
      link.setAttribute('type', 'text/css');
      link.setAttribute('rel', 'stylesheet');
      
      head.appendChild(link);
  });
});


